import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Logo from '../Logo/Logo';
import Link from '@/components/Link/Link';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Stack } from '@mui/material';

const Header = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [searchParams] = useSearchParams();
  const p = searchParams.get('p');
  const myPagesHref = p ? `https://secure.akova.se/my?p=${p}` : 'https://secure.akova.se/my';

  return (
    <AppBar position='static' sx={{ display: { xs: 'none', md: 'block' } }}>
      <Container sx={{ maxWidth: '1200px' }}>
        <Toolbar disableGutters>
          <Stack direction='row' justifyContent='space-between' alignItems='center' width='100%'>
            <Box>
              <Link href={currentLanguage === 'sv' ? 'https://akova.se' : 'https://akova.se/en'}>
                <Logo type='akova' height='40px' width='163' />
              </Link>
            </Box>
            <Stack direction='row' alignItems='center' gap={4}>
              <Link
                href={
                  currentLanguage === 'sv'
                    ? 'https://akova.se/fragor-och-svar/'
                    : 'https://akova.se/en/questions-and-answers/'
                }
                fontWeight='medium'
                variant='body1'
                color='primary.main'
                underline='none'
                sx={{ '&:hover': { color: 'primary.dark' } }}
              >
                {t('components.header.questions-and-answers')}
              </Link>
              <Link
                href={currentLanguage === 'sv' ? 'https://akova.se/#contact' : 'https://akova.se/en/#contact'}
                fontWeight='medium'
                variant='body1'
                color='primary.main'
                underline='none'
                sx={{ '&:hover': { color: 'primary.dark' } }}
              >
                {t('components.header.contact')}
              </Link>
              <Button href={myPagesHref} variant='contained' color='primary' sx={{ fontWeight: 'bold' }}>
                {t('common-phrases.my-pages')}
              </Button>
            </Stack>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
